export default __webpack_public_path__ + "src/assets/frame.5273dc3f722900d70c12bba661366d06.svg";